import React from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import PortalBootstrap from "./PortalBootstrap";
import PortalAuth from "./index";
import PortalPrivateRoutes from "./PortalPrivateRoutes";
import { CataloguePage } from "../catalogue";
import { Cart } from "../cart";
import { OrderHistory } from "../order";
import { PortalInvoicesPage } from "../invoices";
import { PortalStatementsPage } from "../statements";
import { PortalReturnRequestsPage } from "../returns";

/**
 * PortalRoutes
 *
 * Route tree for the entire B2B portal experience.
 *
 * Layout:
 *   PortalBootstrap (shared gate — resolves metadata, hydrates sessions)
 *   ├── auth/*
 *   │   └── PortalAuthRedirect (redirects to /catalog if already authed)
 *   │       └── PortalAuth (login, forgot-password, reset_password, accept_invite)
 *   └── (private)
 *       └── PortalPrivateRoutes (attempts cookie refresh → redirects to login if failed)
 *           ├── catalog
 *           ├── cart
 *           ├── orders
 *           └── index → /catalog
 */
const PortalRoutes = () => {
  return (
    <Routes>
      <Route element={<PortalBootstrap />}>
        {/* ── Auth pages ──────────────────────────────────────────────────────
            PortalAuthRedirect: bounces already-authenticated users to /catalog.
            No refresh API is called here — auth pages are fully public.        */}
        <Route path="auth/*" element={<PortalAuth />} />

        {/* ── Protected pages ─────────────────────────────────────────────────
            PortalPrivateRoutes: checks session → attempts cookie refresh once
            → redirects to /auth/login if unauthenticated.                      */}
        <Route element={<PortalPrivateRoutes />}>
          <Route path="catalog" element={<CataloguePage />} />
          <Route path="cart" element={<Cart />} />
          <Route path="orders" element={<OrderHistory />} />
          <Route path="invoices" element={<PortalInvoicesPage />} />
          <Route path="statements" element={<PortalStatementsPage />} />
          <Route path="returns" element={<PortalReturnRequestsPage />} />
          <Route index element={<Navigate to="catalog" replace />} />
        </Route>
      </Route>
    </Routes>
  );
};

export default PortalRoutes;
